import { combineReducers } from '@reduxjs/toolkit';

import history from './history';
import loading from './loading/loading';
import loaderDarkTheme from './loading/loaderTheme';
import auth from '../components/auth/redux/authenticate';
import notify from './notify/notify';
import page from './page/changeBackground';
import applist from './applist/applist';
import switcher from './switcher/switcher';
import prodSwitcher from './prodswitcher/prodSwitcher';
import prodModeModal from './prodmodemodal/prodModeModal';
import mobileMenu from './mobileMenu/mobileMenu';
import swaggerApi from './swaggerApi/swaggerApi';
import info from './info/info';
import flags from './flags/flags';
import router from './router/router';
import ghost from './reducers/ghost';
import support from './reducers/support';
import environment from './env/env';
import apps from './reducers/apps';
import webhooks from './reducers/webhooks';
import webhook from './reducers/webhook';
import certificates from './reducers/certificates';
import profile from './reducers/profile';

const rootReducer = combineReducers({
  profile,
  certificates,
  webhook,
  webhooks,
  apps,
  auth,
  loading,
  loaderDarkTheme,
  notify,
  page,
  applist,
  switcher,
  mobileMenu,
  prodSwitcher,
  prodModeModal,
  swaggerApi,
  info,
  flags,
  ghost,
  support,
  environment,
  router: router(history),
});

export default rootReducer;
